import React from 'react';
import { FaClock } from 'react-icons/fa';
import { HorarioCard as StyledHorarioCard, HorarioContent } from '../styles/supportStyles';

/**
 * Componente para exibir o horário de atendimento
 * Mostra dias, horário e fuso horário de forma visual com ícone de relógio
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.horarioAtendimento - Objeto com informações de horário
 * @param {string} props.horarioAtendimento.dias - Dias de funcionamento (ex: "Segunda a Sexta")
 * @param {string} props.horarioAtendimento.horario - Horário comercial (ex: "08:00 - 18:00")
 * @param {string} props.horarioAtendimento.timezone - Fuso horário (ex: "BRT", "UTC-3")
 */
export const HorarioCardComponent = ({ horarioAtendimento }) => {
  if (!horarioAtendimento) return null;
  
  return (
    
    <StyledHorarioCard>
      <FaClock />
      <HorarioContent>
        <strong>Horário de Atendimento</strong>
        <p>
          {horarioAtendimento.dias} • {horarioAtendimento.horario} ({horarioAtendimento.timezone})
        </p>
      </HorarioContent>
    </StyledHorarioCard>
  );
};